import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PhoneFormatPipe } from '@libs/patients';
import { PatientContactTypeEnum } from '@ffd/api-client';
import { SecondaryContactVM } from '../../../../health-history-dialog.service';

@Component({
  selector: 'lib-health-history-patient-secondary-contacts',
  standalone: true,
  imports: [NgTemplateOutlet, TranslateModule, PhoneFormatPipe],
  templateUrl: './health-history-patient-secondary-contacts.component.html',
  styleUrl: './health-history-patient-secondary-contacts.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthHistoryPatientSecondaryContactsComponent {
  public readonly contacts = input.required<SecondaryContactVM[]>();

  protected readonly emergency = computed<SecondaryContactVM | undefined>(() =>
    this.contacts().find((c) => c.contactType === PatientContactTypeEnum.EMERGENCY_CONTACT),
  );
  protected readonly pharmacy = computed<SecondaryContactVM | undefined>(() =>
    this.contacts().find((c) => c.contactType === PatientContactTypeEnum.PREFERRED_PHARMACY),
  );
  protected readonly physician = computed<SecondaryContactVM | undefined>(() =>
    this.contacts().find((c) => c.contactType === PatientContactTypeEnum.PHYSICIAN_CONTACT),
  );
}
